import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/firebase-functions'
import 'firebase/firebase-storage'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyBQSRFdMLCaz-3CV8cPP2rgZh-zPs5rk5c",
  authDomain: "travel-teams.firebaseapp.com",
  databaseURL: "https://travel-teams.firebaseio.com",
  projectId: "travel-teams",
  storageBucket: "travel-teams.appspot.com",
  messagingSenderId: "515874907328",
  appId: "1:515874907328:web:8fba000e23ef93ce"
};
//Initialize App
firebase.initializeApp(config);
var otherApp = firebase.initializeApp(config, "other");
const auth2 = otherApp.auth();
const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.functions();
const storage = firebase.storage();
db.settings({
  timestampsInSnapshots: true
});
export {
  db,
  auth,
  functions,
  auth2,
  storage
}